var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "templateList" },
    [
      _vm.templateDialog !== "new"
        ? [
            _c("div", { staticClass: "initial clearfix" }, [
              _vm.showCurrent
                ? _c(
                    "div",
                    {
                      class: ["list", !_vm.currentThumb && "cur"],
                      on: {
                        click: function ($event) {
                          return _vm.selectTemplate({ id: "cur" })
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "img" },
                        [
                          _vm.currentThumb
                            ? _c(
                                "el-image",
                                { attrs: { src: _vm.currentThumb } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "loading",
                                      attrs: { slot: "placeholder" },
                                      slot: "placeholder",
                                    },
                                    [_vm._v("加载中...")]
                                  ),
                                ]
                              )
                            : [
                                _c("i", {
                                  staticClass: "el-icon el-icon-plus",
                                }),
                                _c("div", { staticClass: "tips" }, [
                                  _vm._v(_vm._s(_vm.curTips)),
                                ]),
                              ],
                        ],
                        2
                      ),
                      _c("div", { staticClass: "name" }, [
                        _vm._v(" 当前配置，点击查看/修改 "),
                      ]),
                    ]
                  )
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass: "list new",
                  on: {
                    click: function ($event) {
                      return _vm.selectTemplate({ id: "new" })
                    },
                  },
                },
                [
                  _c("div", { staticClass: "img" }, [
                    _c("i", { staticClass: "el-icon el-icon-plus" }),
                    _c("div", {
                      staticClass: "tips",
                      domProps: { innerHTML: _vm._s(_vm.newTips) },
                    }),
                  ]),
                  _c("div", { staticClass: "name" }, [_vm._v("重新装修")]),
                ]
              ),
            ]),
            _c(
              "div",
              { staticClass: "title2", staticStyle: { fontSize: "14px" } },
              [_vm._v(" 选择模板开始装修 ")]
            ),
          ]
        : _vm._e(),
      Object.keys(_vm.value).length > 0
        ? _c(
            "el-form",
            {
              ref: "searchForm",
              staticClass: "searchForm",
              attrs: { model: _vm.value, inline: "", size: "small" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "页面名称", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入", clearable: "" },
                    model: {
                      value: _vm.value.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "name", $$v)
                      },
                      expression: "value.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        icon: "el-icon-search",
                        loading: _vm.searchLoading,
                      },
                      on: { click: _vm.searchData },
                    },
                    [_vm._v("查询")]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.searchData("reset")
                        },
                      },
                    },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticClass: "mode-wrap" }, [
        _c(
          "span",
          {
            class: ["mode", _vm.mode === "view" && "active"],
            on: {
              click: function ($event) {
                return _vm.changeMode("view")
              },
            },
          },
          [
            _c("i", { staticClass: "el-icon el-icon-picture-outline" }),
            _vm._v(" 视图模式 "),
          ]
        ),
        _c(
          "span",
          {
            class: ["mode", _vm.mode === "list" && "active"],
            on: {
              click: function ($event) {
                return _vm.changeMode("list")
              },
            },
          },
          [
            _c("i", { staticClass: "el-icon el-icon-tickets" }),
            _vm._v(" 列表模式 "),
          ]
        ),
      ]),
      _vm.pages.currentPage == 1 && _vm.list.length < 1
        ? _c("el-empty", { attrs: { "image-size": 200 } })
        : [
            _vm.mode === "list"
              ? _c(
                  "el-table",
                  {
                    staticClass: "myTable",
                    attrs: {
                      "header-cell-style": {
                        background: "#f1f1f1",
                        color: "#333333",
                      },
                      data: _vm.list,
                      border: "",
                    },
                  },
                  _vm._l(_vm.columns, function (item) {
                    return _c("el-table-column", {
                      key: item.prop,
                      attrs: {
                        prop: item.prop,
                        label: item.label,
                        width: item.width,
                        formatter: item.formatter,
                      },
                    })
                  }),
                  1
                )
              : [
                  _c("templateModule", {
                    staticClass: "templateModule",
                    attrs: { templateList: _vm.list },
                    scopedSlots: _vm._u([
                      {
                        key: "handle",
                        fn: function (ref) {
                          var temp = ref.temp
                          return [
                            _c("div", { staticClass: "bottom" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "select",
                                  on: {
                                    click: function ($event) {
                                      return _vm.selectTemplate(temp)
                                    },
                                  },
                                },
                                [_vm._v("选择该模板")]
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
            _vm.pages.currentPage < _vm.pages.totalPage
              ? _c(
                  "div",
                  {
                    class: ["showMore", _vm.loading && "disable"],
                    on: { click: _vm.loadMore },
                  },
                  [
                    _vm._v(" 查看更多 "),
                    _c("i", { staticClass: "el-icon el-icon-arrow-down" }),
                  ]
                )
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }